// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* main container */
.app {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  /*grid-template-rows: 1fr 1fr;*/
  max-height: 100vh;
  gap: 40px;
  justify-items: center;
  align-items: center;
  padding: 50px 0px 50px 0px;
}

/* button container styling */
.button-container {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  gap: 5px;
}

.title-text-container {
  font-size: xx-large;
  text-decoration: none;
  color: inherit;
}

.title-text-container:hover {
  background-color: yellow;
}

.button-start-coord,
.button-end-coord,
.button-initiate-travail,
.button-clear-board {
  max-width: 100px;
}

/* board and board container */
/* using formula for fluid typography to calculate board square size */
/* Check out my other projects at codeberg.org/adriand */
.board-container {
  display: grid;
  grid-template-columns: repeat(
    8,
    minmax(30px, calc(40px + (26 - 16) * ((100vw - 300px) / (2800 - 300))))
  );
  grid-template-rows: repeat(
    8,
    minmax(30px, calc(40px + (26 - 16) * ((100vw - 300px) / (2800 - 300))))
  );
  aspect-ratio: 1 / 1;
}

.board-element {
  display: grid;
  place-items: center;
  overflow: hidden;
}

/* alternative cell color */
.light-board-element {
  background-color: aliceblue;
}

.dark-board-element {
  background-color: #a47764; /* Use Pantone Color of the Year 2025, Mocha Mousse :) */
}

/* element changes color when becomes start, end, and intermediate positions */
.start-position {
  border: calc(2px + (26 - 16) * ((100vw - 300px) / (2800 - 300))) solid
    greenyellow;
}

.end-position {
  border: calc(2px + (26 - 16) * ((100vw - 300px) / (2800 - 300))) solid red;
}

.intermediate-position:not(.start-position, .end-position) {
  border: calc(2px + (26 - 16) * ((100vw - 300px) / (2800 - 300))) solid yellow;
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B,sEAAsE;AACtE,wDAAwD;AACxD;EACE,aAAa;EACb;;;GAGC;EACD;;;GAGC;EACD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,wDAAwD;AACrF;;AAEA,8EAA8E;AAC9E;EACE;eACa;AACf;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,6EAA6E;AAC/E","sourcesContent":["/* main container */\n.app {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  /*grid-template-rows: 1fr 1fr;*/\n  max-height: 100vh;\n  gap: 40px;\n  justify-items: center;\n  align-items: center;\n  padding: 50px 0px 50px 0px;\n}\n\n/* button container styling */\n.button-container {\n  display: grid;\n  grid-template-columns: 1fr;\n  justify-items: center;\n  gap: 5px;\n}\n\n.title-text-container {\n  font-size: xx-large;\n  text-decoration: none;\n  color: inherit;\n}\n\n.title-text-container:hover {\n  background-color: yellow;\n}\n\n.button-start-coord,\n.button-end-coord,\n.button-initiate-travail,\n.button-clear-board {\n  max-width: 100px;\n}\n\n/* board and board container */\n/* using formula for fluid typography to calculate board square size */\n/* Check out my other projects at codeberg.org/adriand */\n.board-container {\n  display: grid;\n  grid-template-columns: repeat(\n    8,\n    minmax(30px, calc(40px + (26 - 16) * ((100vw - 300px) / (2800 - 300))))\n  );\n  grid-template-rows: repeat(\n    8,\n    minmax(30px, calc(40px + (26 - 16) * ((100vw - 300px) / (2800 - 300))))\n  );\n  aspect-ratio: 1 / 1;\n}\n\n.board-element {\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n/* alternative cell color */\n.light-board-element {\n  background-color: aliceblue;\n}\n\n.dark-board-element {\n  background-color: #a47764; /* Use Pantone Color of the Year 2025, Mocha Mousse :) */\n}\n\n/* element changes color when becomes start, end, and intermediate positions */\n.start-position {\n  border: calc(2px + (26 - 16) * ((100vw - 300px) / (2800 - 300))) solid\n    greenyellow;\n}\n\n.end-position {\n  border: calc(2px + (26 - 16) * ((100vw - 300px) / (2800 - 300))) solid red;\n}\n\n.intermediate-position:not(.start-position, .end-position) {\n  border: calc(2px + (26 - 16) * ((100vw - 300px) / (2800 - 300))) solid yellow;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
